<template>
	<span class="badge" :class="[{up:!!up},setImp]">{{showValue}}</span>
</template>

<script>
	import lib from "../../assets/js/lib.js"
	export default {
		name: 'bsf-badges',
		components: {},
		props: {
			val: {},
			max: {
				type: Number,
				default: 99
			},
			show: Boolean,
			dot: Boolean,
			up: Boolean,
			imp: Boolean
		},
		data() {
			return {}
		},
		methods: {},
		mounted: function() {
			this.$nextTick(function() {})
		},
		computed: {
			showValue() {
				if(this.dot) return;
				const val = this.val;
				const max = this.max;
				if(typeof val === 'number' && typeof max === 'number') {
					return val >= max ? `${max}+` : val;
				} else {
					return val
				}
			},
			setImp() {
				return this.imp ? "imp" : ""
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.badge {
		&.up {
			top: -10px;
			right: -5px;
			position: absolute;
		}
		&.imp {
			background-color: @cre ;
		}
	}
</style>


// WEBPACK FOOTER //
// badges.vue?9ab958b0